import { render, staticRenderFns } from "./ListBatchClassification.vue?vue&type=template&id=7896e8b6&"
import script from "./ListBatchClassification.vue?vue&type=script&lang=js&"
export * from "./ListBatchClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7896e8b6')) {
      api.createRecord('7896e8b6', component.options)
    } else {
      api.reload('7896e8b6', component.options)
    }
    module.hot.accept("./ListBatchClassification.vue?vue&type=template&id=7896e8b6&", function () {
      api.rerender('7896e8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/lists/ListBatchClassification.vue"
export default component.exports